import React, { useEffect, useState } from "react";
import socketIOClient from "socket.io-client";
import { Circle } from "lucide-react";

const OnlineUsers = ({ userData }) => {
  const [onlineUsers, setOnlineUsers] = useState([]);

  useEffect(() => {
    const socket = socketIOClient(process.env.REACT_APP_API_URL);

    socket.on("connect", () => {
      socket.emit("newUser", userData.name + " " + userData.firstname);
    });

    socket.on("disconnect", () => {
      socket.emit("disconnectUser", "current-user-name");
    });

    socket.on("onlineUsers", (users) => {
      setOnlineUsers(users);
    });

    return () => {
      if (socket.readyState === 1) {
        socket.disconnect();
      }
    };
  }, [userData]);

  return (
    <div className="dash-online">
      <span className="dash-online-count">{onlineUsers.length} en ligne</span>
      {onlineUsers.length === 0 ? (
        <p className="dash-empty">Aucun utilisateur connecté pour le moment.</p>
      ) : (
        <ul className="dash-online-list">
          {onlineUsers.map((user) => (
            <li className="dash-online-item" key={user._id}>
              <Circle size={9} fill="#10b981" color="#10b981" />
              {user.username}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default OnlineUsers;
